import { Component, OnInit, Input } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { OwlPreventClickDirective } from '../../shared/directives/owl-prevent-click.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-block-categories-slider',
    templateUrl: './block-categories-slider.component.html',
    styleUrls: ['./block-categories-slider.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [MatIconModule, MatRippleModule, CarouselModule, OwlPreventClickDirective, NgFor, RouterLink]
})
export class BlockCategoriesSliderComponent implements OnInit {
    @Input() bgColor;
    @Input() fgColor;
    @Input() categories;
    @Input() slides = {
        lgScreen: 5,
        smScreen: 4,
        tablet: 2,
        mobile: 1
    };

    constructor(
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private direction: DirectionService,

    ) { }

    ngOnInit(): void {
        // console.log("CATEGORY:: ", this.category);
        this.carouselOptions.responsive = {
            1110: { items: this.slides?.lgScreen || 5, margin: 12 },
            930: { items: this.slides?.smScreen || 4, margin: 8 },
            690: { items: this.slides?.tablet || 4, margin: 6 },
            0: { items: this.slides?.mobile || 1 }
        }
    }
    carouselOptions: any = {
        lazyLoad: true,
        items: 5,
        margin: 12,
        nav: false,
        dots: false,
        loop: true,
        skip_validateItems: true,
        stagePadding: 1,
        rtl: this.direction.isRTL(),
        responsive: {
            1110: { items: 5, margin: 12 },
            930: { items: 4, margin: 8 },
            690: { items: 2, margin: 6 },
            0: { items: 1 }
        }
    };

}
